
import { defineComponent, reactive, ref, watch } from '@nuxtjs/composition-api';
import useOpenClose from '~/composables/useOpenClose';
import { onClickOutside } from '@vueuse/core';

export default defineComponent({
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [
        { text: 'Featured', name: 'order[best_seller]' },
        { text: 'Newest', name: 'order[new]' },
      ],
    },
  },
  setup(props, { emit }) {
    const { isOpen, open, close } = useOpenClose();
    const wrap = ref();
    const sorting = reactive({
      field: undefined,
      order: undefined,
    });

    const toggleOpenClose = () => {
      isOpen.value ? close() : open();
    };

    const getSortingOrder = (order) => {
      if (order !== sorting.field) return 'desc';
      return undefined;
    };

    const changeOrder = (field) => {
      const order = getSortingOrder(field);

      emit('input', { ...(order && { [field]: order }) });
      close();
    };

    onClickOutside(wrap, () => close());

    watch(
      () => props.value,
      (value) => {
        let field;
        let order;

        if (value) [field, order] = Object.entries(value)[0] ?? [];

        sorting.field = field;
        sorting.order = order;
      },
      { immediate: true },
    );

    return {
      wrap,
      sorting,
      isOpen,
      open,
      close,
      toggleOpenClose,
      changeOrder,
    };
  },
});
